import React, { useState, useEffect, useRef } from "react";
import { ActualizarAgenteRetencion } from "../../hacienda/actividadEconomica/modalActualizarAgenteRetencion";
import { Mensaje } from "../../mensajes";

import { Dimmer } from "../../spinner";

import useTable from "../../useTable";
import axios from "axios";
import { ModalImpuestoTasa } from "./modalAgregarTasa";
import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
} from "../../../util/varios";

function TablaTributaria(props) {
  const factorCambio = JSON.parse(localStorage.getItem("factorCambio"));

  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const headCells = [
    {
      id: "",
      label: "CODIGO",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "",
      label: "CANTIDA",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "",
      label: "DESCRIPCION DE LA TASA",
      width: "300px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "",
      label: "MONTO A PAGAR",
      width: "300px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "",
      label: "CANCELADA",
      width: "100px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "",
      label: "",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];

  /* variables de estado */
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar, setMostrar] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [contar, setContar] = useState(0);
  const [contar2, setContar2] = useState(0);
  const [contar4, setContar4] = useState(0);
  const [contar6, setContar6] = useState(0);
  const [contarRet, setContarRet] = useState(0);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [comercio, setComercio] = useState();
  const [persona, setPersona] = useState();
  const [statusCome, setStatusCome] = useState();
  const [usuariow, setUsuariow] = useState();
  const [idUsuario, setIdUsuario] = useState();
  const [retencion, setRetencion] = useState();
  const [espiritu, setEspiritu] = useState(localStorage.getItem("espiritu"));
  const [anioActu, setAnioActu] = useState(localStorage.getItem("anioactu"));
  const [ipMac, setIpMac] = useState({
    ip: localStorage.getItem("ip"),
    mac: localStorage.getItem("mac"),
  });
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [permiso, setPermiso] = useState();
  const [horaope, setHoraope] = useState();
  const [declaWeb, setDeclaWeb] = useState(false);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [mostarModal, setMostrarModal] = useState(false);
  const [anio, setAnio] = useState();
  const txtAnio = useRef();
  const [tasas, setTasas] = useState();
  const [tipoTasas, setTipoTasas] = useState();
  const [valorUnidad, setValorUnidad] = useState();
  const [montoTipTas, setMontoTipTas] = useState();
  const [annio, setAnnio] = useState();
  const [periodo, setPeriodo] = useState();
  const [factor, setFactor] = useState();

  const blanquearCampos = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setTasas();
    setTipoTasas();
  };

  const cerrarContri = () => {
    setMostrarModal(false);
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const onChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;

    if (name === "anioTasa") {
      console.log(value);
      console.log(props.idcomercio);
      if (value !== "") {
        seleccionarDetalle(props.idcomercio, value);
      } else if (value === "") {
      }
    }
  };

  const seleccionarDetalle = (id, nanio) => {
    let nomtab = "licores";
    let nomid = "idcomercio";

    let endpoint = `${op.conexion}/api/licores/tasalicores?nomtab=${nomtab}&nomid=${nomid}&id=${id}&nanio=${nanio}`;
    console.log(endpoint);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
          setAnnio(nanio);
        }

        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "configlicores";
    let orden = "1";

    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    console.log(endpoint);

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setPeriodo(response.data.periodopago);
          setFactor(response.data.factorcalculo);
          setDeclaWeb(response.data.declaracionweb);
          console.log(response.data);
        }

        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const seleccionarRegistro = (idlicores) => {
    let campos = "*";
    let nomtab = "licores";
    let nomid = "idlicores";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idlicores}&nomtab=${nomtab}&nomid=${nomid}`;
    console.log(endpoint);
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idlicores > 0) {
            setTasas(response.data);
            console.log(response.data);
            seleccionarTipoTasa(response.data);
          }

          setActivate(false);
        }
      })
      .catch((error) => {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const seleccionarTipoTasa = (data) => {
    let campos = "*";
    let nomtab = "tipotasa";
    let nomid = "idtipotasa";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.idtipotasa}&nomtab=${nomtab}&nomid=${nomid}`;
    console.log(endpoint);
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idtipotasa > 0) {
            setTipoTasas(response.data);
            setMontoTipTas(response.data.monto);
            setMostrarModal(true);
          } else {
            setMostrarModal(true);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const seleccionarValorUnidad = () => {
    let campos = "*";
    let nomtab = "unidadtributaria";
    let nomid = "anio";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${anioActu}&nomtab=${nomtab}&nomid=${nomid}`;
    console.log(endpoint);
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idunidadtributaria > 0) {
            setValorUnidad(response.data);
            console.log(response.data);
          }

          setActivate(false);
        }
      })
      .catch((error) => {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const handleCloseMensa = () => {
    setMostrar(false);
    blanquearCampos();
  };

  const cerrarModalActualizar = () => {
    setMostrar5(false);
  };

  useEffect(() => {
    let anioact = JSON.parse(localStorage.getItem("anioactu"));
    var nanio = [];
    var aini = parseInt(anioact) - 7;
    var afin = parseInt(anioact);

    for (let i = 0; i + aini <= afin; i++) {
      nanio.push({ anio: afin - i });
    }
    setAnio(nanio);
    seleccionarValorUnidad();
    seleccionarRegistros();
    seleccionarDetalle(props.idcomercio, parseInt(anioActu));
    console.log(parseInt(anioActu));
  }, []);

  const opciones = (ope, id) => (event) => {
    event.preventDefault();

    if (txtAnio.current.value === "") {
      setTitulo("Notificacion");
      setMsg("Debe seleccionar un año.");
      setMostrar(true);
      txtAnio.current.focus();
    } else {
      if (ope === 1) {
        setMostrarModal(true);
        setOperacion(1);
        blanquearCampos();
        console.log("1");
      } else if (ope === 3) {
        setOperacion(3);
        console.log("3");
        seleccionarRegistro(id);
      }
    }
  };
  return (
    <div className="card">
      <ModalImpuestoTasa
        show={mostarModal}
        onHideCancela={cerrarContri}
        petro={props.petro}
        tasas={tasas}
        tipoTasas={tipoTasas}
        blanquear={blanquearCampos}
        valorUnidad={valorUnidad}
        montoTipTas={montoTipTas}
        idcomercio={props.idcomercio}
        annio={annio}
        operacion={operacion}
        onHIdeRenderizar={seleccionarDetalle}
        onHideRenderDeu={props.onHideRenderDeu}
        comercio={props.comercio}
      />
      <Mensaje
        titulo={titulo}
        mensaje={msg}
        show={mostrar}
        onHide={handleCloseMensa}
      />

      <Dimmer active={activate} inverted></Dimmer>

      {/* /.card-header */}
      <div className="card-body">
        <div className="content">
          <div className="">
            <div className="row col-md-12 mx-auto">
              <div
                class="input-group input-group-sm col-md-2"
                style={{ margin: 0, height: 27 }}
              >
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm">
                    {" "}
                    Año:
                  </span>
                </div>
                <select
                  ref={txtAnio}
                  name="anioTasa"
                  onChange={onChange}
                  className="form-control form-control-sm col-md-6"
                >
                  {anio &&
                    anio.map((a) => (
                      <option key={a.anio} value={a.anio}>
                        {a.anio}
                      </option>
                    ))}
                </select>
              </div>

              <div className="col-md-8"></div>

              <div className="col-md-2">
                <div className="col-md-12 d-flex justify-content-end">
                  <button
                    disabled={props.disabled === true ? false : true}
                    style={{ marginBottom: "10px" }}
                    onClick={opciones(1, "")}
                    className="btn btn-sm btn-primary rounded-pill"
                  >
                    <i className="fas fa-plus">
                      <small>Incluir</small>
                    </i>{" "}
                  </button>
                </div>
              </div>

              <div
                className="col-md-12"
                style={{ margin: "auto", marginTop: "1%" }}
              >
                <TblContainer>
                  <TblHead />

                  <tbody>
                    {records &&
                      recordsAfterPagingAndSorting().map((item, index) => (
                        <tr
                          key={item.idlicores}
                          style={{ padding: "0", height: "40px" }}
                        >
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "10px",
                              height: "40px",
                            }}
                          >
                            {item.codigo}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "80px",
                              height: "40px",
                            }}
                          >
                            {item.cantidad}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "200px",
                              height: "40px",
                            }}
                          >
                            {item.descripcion}{" "}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "100px",
                              height: "40px",
                            }}
                          >
                            {formatMoneda(
                              (parseFloat(item?.monto) *
                                parseFloat(item?.cantidad) *
                                parseFloat(factorCambio?.valor))
                                  .toString()
                                  .replace(".", ","),
                              ",",
                              ".",
                              2,
                            )}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "100px",
                              height: "40px",
                            }}
                          >
                            {item.cancelada === true ? "SI" : "NO"}{" "}
                          </td>

                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "40px",
                              height: "40px",
                            }}
                          >
                            <button
                              onClick={opciones(3, item.idlicores)}
                              disabled={props.disabled === true ? false : true}
                              className="btn btn-sm btn-danger rounded-circle"
                            >
                              <i className="fa fa-trash-alt"></i>{" "}
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </TblContainer>
                <TblPagination />
              </div>
            </div>
          </div>
        </div>

        <div className="row"></div>
      </div>
    </div>
  );
}

export default TablaTributaria;
